app.controller(
    'AdminGeneralController', ['$scope', '$rootScope', '$http', '$stateParams', 'Configuration', 'AdminService', '$translate', AdminGeneralController]
);

function AdminGeneralController($scope, $rootScope, $http, $stateParams, Configuration, AdminService, $translate) {
    var vm = this;


    $translate.use($rootScope.LangForInterface);

    initController();

    function initController() {
        getAdminGeneralInfo();
    }

    $rootScope.AdminConfiguration = {
        ckEditorStyleSheet: [],
        FieldSizeObject: {}
    };

    function getAdminGeneralInfo() {
        AdminService.getAdminGeneralInfo()
            .then(function (res) {
                $rootScope.ZoneInfos = res.data;
                $rootScope.AdminConfiguration.ckEditorStyleSheet = JSON.parse(res.data.ckEditorStyleSheetGeneral);
                $rootScope.AdminConfiguration.FieldSizeObject.LengthLimitOfDescInPlace = res.data.LengthLimitOfDescInPlace;
                $rootScope.AdminConfiguration.FieldSizeObject.LengthLimitOfDescInItinerary = res.data.LengthLimitOfDescInItinerary;

                $rootScope.AdminConfiguration.FieldSizeObject.LengthLimitOfDescInItinerary6560 = res.data.LengthLimitOfDescInItinerary6560;
                $rootScope.AdminConfiguration.FieldSizeObject.LengthLimitOfDescInItinerary10588 = res.data.LengthLimitOfDescInItinerary10588;

                $rootScope.AdminConfiguration.FieldSizeObject.LengthLimitOfDescInBio = res.data.LengthLimitOfDescInBio;

                $rootScope.AdminConfiguration.FieldSizeObject.LengthLimitOfDescInDistrict = res.data.LengthLimitOfDescInDistrict;

                $rootScope.AdminConfiguration.FieldSizeObject.LengthLimitOfDescInGroup10584 = res.data.LengthLimitOfDescInGroup10584;
                $rootScope.AdminConfiguration.FieldSizeObject.LengthLimitOfDescInGroup10585 = res.data.LengthLimitOfDescInGroup10585;
                $rootScope.AdminConfiguration.FieldSizeObject.LengthLimitOfDescInGroup10586 = res.data.LengthLimitOfDescInGroup10586;
                //$scope.updateFieldTags();
            });
    }

    $scope.formatGens = [
        {
            id: 1,
            openDropdown: false
        }
    ];

    /**
     * add format general
     */
    $scope.addGenFormat = function () {
        $rootScope.AdminConfiguration.ckEditorStyleSheet.push({
            name: "",
            element: ""
        })
    };

    /**
     * Remove format (Format general)
     * @param format
     */
    $scope.removeGenFormat = function (format) {
        $rootScope.AdminConfiguration.ckEditorStyleSheet.splice(format, 1);
    };

    vm.ResetFieldSize= function () {
        AdminService.ResetFieldSize()
            .then(function (res) {
                window.location.reload();
            });        
    };

    vm.UpdateFieldSize = function () {
        AdminService.UpdateFieldSize($rootScope.AdminConfiguration.FieldSizeObject);
    };

    $scope.UpdateStyleSheet = function () {
        for (var i = 0; i < $rootScope.AdminConfiguration.ckEditorStyleSheet.length; i++) {
            $rootScope.AdminConfiguration.ckEditorStyleSheet[i].attributes = {
                class: $rootScope.AdminConfiguration.ckEditorStyleSheet[i].name                
            }
        }
        AdminService.UpdateStyleSheet($rootScope.AdminConfiguration.ckEditorStyleSheet);        
    };
}